import Chart from '@/chart'
import { verticalStratification } from '@/assets/charts/plugins/backgroundStratification'

export function parseData(data, target_states){
    return data.map((values, index) => 100*values[target_states[index]])
}

export function initChart(ctx, labels, data, params={}){

    const datasets = [{
        data,
        backgroundColor: 'black'   
    }]

    console.log('Target states', params.target_states)

    let options = {
        scales: {
            y: {
                min: 0,
                max: 100,
                display: true,
                ticks: {
                    callback: function(value){
                        return `${value}%`
                    }
                }
            }
        },
        aspectRatio: 1,
        plugins: {
            legend: {
                display: false
            },
            tooltip: {
                callbacks: {
                    label: function(context){
                        let value = context.raw                      
                        return `${(value).toFixed(1)}%`
                    }
                }
            },
            verticalStratification: {
                strata: params.strata,
                pallete: params.strataColor,
                scaleStrata: 1
            }
        }
    }
    
    let config = {
        type: 'line',
        data: {
            labels,
            datasets
        },
        options,
        plugins: [verticalStratification]
    }

    return new Chart(ctx, config)

}